document.addEventListener('DOMContentLoaded', function() {
  // Target video wrappers within sections with the 'video-section' class
  var videoSections = document.querySelectorAll('.video-section');

  videoSections.forEach(function(section) {
    var videoWrapper = section.querySelector('.video-wrapper');
    // Check if the wrapper has an iframe or video tag
    if (!videoWrapper.querySelector('iframe, video')) {
      // If not, hide the wrapper
      videoWrapper.style.display = 'none';
    }
  });
});
